import {
  GetString,
} from 'fluent-react';
import React, {useState} from 'react';
import styled from 'styled-components';
import { extractFromStringLocationId } from '../../graphQL/Utils';
import { googleAnalyticsEvent } from '../../useGoogleAnalytics';
import { smallMediaQuery } from '../Grid';
import { primaryColor1 } from '../Utils';
import {
  Container,
  SvgContainer,
  svgHeight,
  svgWidth,
} from './sharedStyling';

const NewTabArrow = styled.div`
  position: absolute;
  bottom: 0;
  right: 0.6rem;
  width: 0.825rem;

  svg {
    width: 100%;
    height: 100%;
  }

  @media ${smallMediaQuery} {
    right: 2px;

    svg {
      width: 50%;
      height: 50%;
    }
  }
`;

const MagnifyingGlass = styled(SvgContainer)`
  svg {
    width: ${svgWidth}px;
    height: ${svgHeight}px;
  }

  @media ${smallMediaQuery} {
    svg {
      width: ${svgWidth / 2}px;
      height: ${svgHeight / 2}px;
    }
  }
`;

const AlertIcon = styled.div`
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;
  margin-right: 0.5rem;
  margin-top: 0.3rem;

  svg {
    width: 100%;
    height: 100%;
    stroke: #fff;
    stroke-width: 4px;
    fill: none;
  }
`;

const Link = styled.a`
  color: white;
  font-size: 1.5rem;
  text-transform: uppercase;
  line-height: 1.5;
  padding: 1.2rem 1.5rem;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: ${primaryColor1};
  width: 100%;
  height: 100%;

  svg {
    fill: white;
  }

  &:hover {
    background: white;
    color: ${primaryColor1};

    svg {
      fill: ${primaryColor1};
    }
  }

  @media ${smallMediaQuery} {
    font-size: 0.6rem;
    padding: 0.6rem;
  }
`;

const Tooltip = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(calc(-100% - 0.7rem));
  background-color: ${primaryColor1};
  color: #fff;
  padding: 0.7rem 0.3rem 0.7rem 0.5rem;
  text-transform: none;
  font-size: 0.8em;
  text-align: left;
  display: flex;
  justify-content: center;
  margin: 0 -2rem;
  line-height: 1.4;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    right: 0;
    bottom: 0;
    transform: translate(-50%, 90%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${primaryColor1};
  }

  @media (max-width: 1150px) {
    margin: 0;
  }
`;

interface Props {
  countryId: string;
  getFluentString: GetString;
}

const ExploreCitiesButton = (props: Props) => {
  const {
    countryId, getFluentString,
  } = props;

  const locationIDNumber = extractFromStringLocationId(countryId);
  const [hovered, setHovered] = useState<boolean>(false);

  const dataNotesSVGString = require('../../sharedComponents/newGraphShare/datanotes_on.svg');
  const tooltip = hovered ? (
    <Tooltip>
      <AlertIcon
        dangerouslySetInnerHTML={{__html: dataNotesSVGString}}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: getFluentString('conclusion-slide-text-explore-country-in-metroverse-tooltip'),
        }}
      />
    </Tooltip>
  ) : null;

  return (
    <Container>
      <Link
        href={`https://metroverse.hks.harvard.edu/?country=${locationIDNumber}`}
        target='_blank'
        onClick={() => googleAnalyticsEvent(
          'Country Profiles Conclusion Explore Metroverse',
          'click -- explore further in Metroverse',
        )}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <MagnifyingGlass
            dangerouslySetInnerHTML={{__html: require('../topProductsTable/magnifying-glass-plus.svg')}}
        />
        <span>
          {getFluentString('conclusion-slide-text-explore-country-in-metroverse')}
        </span>
        <NewTabArrow
          dangerouslySetInnerHTML={{__html: require('../topProductsTable/diagonal-right-arrow.svg')}}
        />
      </Link>
      {tooltip}
    </Container>
  );
};

export default ExploreCitiesButton;
